
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export class TimeLine {
    constructor() {
        this.initAll();
    }

    private initAll() {
        document.querySelectorAll<HTMLElement>('.timeline').forEach((root) => {
            this.initInstance(root);
        });
    }

    private initInstance(root: HTMLElement) {
        const speed = root.dataset.speed ? parseInt(root.dataset.speed, 10) : 1500;

        const datesEl = root.querySelector('.timeline-dates') as HTMLElement | null;
        if (!datesEl) return;

        const timelineDates = new Swiper(datesEl, {
            modules: [Navigation],
            spaceBetween: 15,
            slidesPerView: 'auto',
            centeredSlides: false,
            slidesOffsetBefore: 160,
            slidesOffsetAfter: 160,
            watchOverflow: false,
            resistanceRatio: 0.85,
            initialSlide: 0,
            grabCursor: true,
            touchRatio: 1,
            slideToClickedSlide: true,
            speed: speed,
            freeMode: false,
            effect: 'slide',
            navigation: {
                nextEl: '.timeline-button-next',
                prevEl: '.timeline-button-prev'
            }
        });

        timelineDates.slideTo(0, 0);

        const wrapper = datesEl.querySelector('.swiper-wrapper') as HTMLElement;
        if (wrapper) {
            wrapper.style.transitionTimingFunction = 'ease';
            wrapper.style.transitionDuration = speed + 'ms';
        }


        timelineDates.on('slideChangeTransitionStart', () => {
            timelineDates.slides.forEach((slide, index) => {
                const dateEl = slide.querySelector('div:first-child') as HTMLElement;
                if (dateEl) {
                    // Force transition property to be applied with synchronized timing
                    dateEl.style.transition = 'font-size 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94), color 0.5s ease';
                    dateEl.style.willChange = 'font-size, transform, color';
                }
            });
        });


        const resizeHandler = () => {
            const isMobile = window.matchMedia('(max-width: 767px)').matches;
            timelineDates.params.slidesOffsetBefore = isMobile ? 24 : 160;
            timelineDates.params.slidesOffsetAfter = isMobile ? 24 : 24;
            timelineDates.update();
        };
        window.addEventListener('resize', resizeHandler);
        resizeHandler();

        const datesTrack = datesEl as HTMLElement;
        const computeLayout = () => {
            if (!!datesTrack) return;

            const activeSlide = datesTrack.querySelector('.swiper-slide.swiper-slide-active') as HTMLElement | null
                || datesTrack.querySelector('.swiper-slide') as HTMLElement | null;
            const yearEl = activeSlide?.querySelector('.timeline-year') as HTMLElement | null
                || (activeSlide?.querySelector(':scope > div') as HTMLElement | null);

            const yearBox = yearEl?.getBoundingClientRect();
            const trackBox = datesTrack.getBoundingClientRect();
            let baselineTop = 42;
            if (yearBox && trackBox) {
                const yearBottom = yearBox.bottom - trackBox.top;
                baselineTop = Math.round(yearBottom + 12);
            }
            datesTrack.style.setProperty('--timeline-baseline-top', baselineTop + 'px');

            const descEl = activeSlide?.querySelector('.timeline-desc') as HTMLElement | null;
            let minHeight = baselineTop + 1;
            if (descEl) {
                const descBox = descEl.getBoundingClientRect();
                const descHeight = Math.round(descBox.height) || 0;
                minHeight = baselineTop + 16 + descHeight + 16;
            }
            datesTrack.style.minHeight = minHeight + 'px';
        };

        const ensureConnectors = () => {
            datesEl.querySelectorAll<HTMLElement>('.swiper-slide').forEach(slide => {
                if (!slide.querySelector('.timeline-connector')) {
                    const el = document.createElement('div');
                    el.className = 'timeline-connector';
                    slide.appendChild(el);
                }
            });
        };
        ensureConnectors();

        const updateConnector = () => {
            const slides = Array.from(datesEl.querySelectorAll<HTMLElement>('.swiper-slide'));
            const active = datesEl.querySelector<HTMLElement>('.swiper-slide.swiper-slide-active');
            slides.forEach(slide => {
                const connector = slide.querySelector('.timeline-connector') as HTMLElement | null;
                if (!connector) return;
                if (slide !== active) {
                    connector.style.height = '0px';
                    return;
                }
                const desc = slide.querySelector('.date-description') as HTMLElement | null;
                if (!desc) { connector.style.height = '0px'; return; }

                // Responsive positioning: baseline + gap + description height
                const BASELINE_OFFSET = 0; // px above the slide bottom to hit the dot baseline

                // Match CSS breakpoints for gap size
                const isMobile = window.matchMedia('(max-width: 639px)').matches;
                const isTablet = window.matchMedia('(min-width: 640px) and (max-width: 1023px)').matches;
                const DESC_GAP = isMobile || isTablet ? 12 : 42; // 12px mobile/tablet, 42px desktop
                const slideBox = slide.getBoundingClientRect();
                const descBox = desc.getBoundingClientRect();
                const baselineFromTop = Math.round(slideBox.height - BASELINE_OFFSET);

                connector.style.top = baselineFromTop + 'px';
                connector.style.bottom = '';

                // Responsive calculation: baseline to description start + description height
                const descHeight = Math.round(descBox.height) || 0;
                const target = DESC_GAP + descHeight;
                connector.style.height = target + 'px';
            });
        };

        const hideAllConnectors = () => {
            const slides = Array.from(datesEl.querySelectorAll<HTMLElement>('.swiper-slide'));
            slides.forEach(slide => {
                const connector = slide.querySelector('.timeline-connector') as HTMLElement | null;
                if (connector) {
                    connector.style.height = '0px';
                }
            });
        };

        updateConnector();
        window.addEventListener('resize', updateConnector);
        timelineDates.on('slideChangeTransitionStart', hideAllConnectors);
        timelineDates.on('slideChangeTransitionEnd', updateConnector);
        timelineDates.on('resize', updateConnector);
        computeLayout();
        window.addEventListener('resize', computeLayout);
        timelineDates.on('slideChangeTransitionEnd', computeLayout);
        return;

    }
}

